export default function CsharpSwitchExpression() {
  return (
    <h2>Csharp Switch Expression</h2>
  );
}
